import { FormSkeleton } from '@globaleris/ui.library'
import { List, ListItem, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(() => ({
  list: {
    '& > *': {
      display: 'table'
    }
  }
}))

interface PriceComponentTypeLeftPanelDetailsProps {
  isLoading?: boolean
  code: string
  description: string
  priceType: string
  referenceType: string
  commodity: string
}

export const PriceComponentTypeLeftPanelDetails: React.FC<
  PriceComponentTypeLeftPanelDetailsProps
> = ({ isLoading = false, code, description, priceType, referenceType, commodity }) => {
  const classes = useStyles()
  const [t] = useTranslation(['globalerisLibrary', 'enums', 'priceComponentTypeInstances'])

  return (
    <>
      {isLoading ? (
        <FormSkeleton withTitle={true} elevation={0} columns={1} inputs={3} />
      ) : (
        <>
          <Typography variant="h1" color="primary" noWrap>
            {t('priceComponentTypeInstances:leftColumn.title')}
          </Typography>
          <List className={classes.list}>
            <ListItem divider disableGutters>
              <Typography variant="h2">
                {t('priceComponentTypeInstances:leftColumn.subtitle')}
              </Typography>
            </ListItem>
            <ListItem divider disableGutters>
              <Typography variant="caption">
                {t('priceComponentTypeInstances:leftColumn.captions.code')}
              </Typography>
              <Typography variant="body2">{code}</Typography>
            </ListItem>
            <ListItem divider disableGutters>
              <Typography variant="caption">
                {t('priceComponentTypeInstances:leftColumn.captions.description')}
              </Typography>
              <Typography variant="body2">{description}</Typography>
            </ListItem>
            <ListItem divider disableGutters>
              <Typography variant="caption">
                {t('priceComponentTypeInstances:leftColumn.captions.priceType')}
              </Typography>
              <Typography variant="body2">{priceType}</Typography>
            </ListItem>
            <ListItem divider disableGutters>
              <Typography variant="caption">
                {t('priceComponentTypeInstances:leftColumn.captions.referenceType')}
              </Typography>
              <Typography variant="body2">{referenceType}</Typography>
            </ListItem>
            <ListItem divider disableGutters>
              <Typography variant="caption">
                {t('priceComponentTypeInstances:leftColumn.captions.commodity')}
              </Typography>
              <Typography variant="body2">{commodity}</Typography>
            </ListItem>
          </List>
        </>
      )}
    </>
  )
}
